import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

export interface Video {
  _id: string;
  project: {
    _id: string;
    name: string;
    azurePath: string;
  };
  title: string;
  description: string;
  url: string;
  mimetype: string;
  sizeBytes: number;
  thumbnailUrl: string;
  supportingFiles: string[];
  createdBy: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  views?: number;
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class VideoService {
  constructor(private api: ApiService) {}

  getUsers(): Observable<any[]> {
    return this.api.get<any[]>('/users');
  }

  getVideos(): Observable<Video[]> {
    return this.api.get<Video[]>('videos');
  }

  getVideosByProject(projectId: string, search?: string, projectModule?: string, sortOrder: string = 'desc', limit: number = 8, offset: number = 0): Observable<{videos: Video[]; totalCount: number}> {
    let url = `/videos/project/${projectId}`;
    const params: string[] = [];
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (projectModule && projectModule !== 'all') params.push(`projectModule=${projectModule}`);
    if (sortOrder) params.push(`sortOrder=${sortOrder}`);
    if (limit) params.push(`limit=${limit}`);
    if (offset) params.push(`offset=${offset}`);
    if (params.length) url += `?${params.join('&')}`;
    return this.api.get<{videos: Video[]; totalCount: number}>(url);
  }


  getVideoDetails(videoId: string, userId: string): Observable<any> {
    return this.api.get(`/videos/${videoId}?userId=${userId}`);
  }

  toggleLike(videoId: string, userId: string): Observable<any> {
    return this.api.post(`/videos/${videoId}/like`, { userId });
  }

  toggleFavorite(videoId: string, userId: string): Observable<any> {
    return this.api.post(`/favorites/video/${videoId}`, { userId });
  }

  addComment(videoId: string, userId: string, text: string): Observable<any> {
    return this.api.post(`/videos/${videoId}/comment`, { userId, text });
  }

  getVideosByProjectAndModule(projectId: string, projectModuleId: string): Observable<Video[]> {
    return this.api.get<Video[]>(`/videos/project/${projectId}?projectModule=${projectModuleId}`);
  }

   addView(videoId: string, userId: number): Observable<{ success: boolean, viewId: string }> {
    return this.api.post(`/videos/${videoId}/view`, { userId });
  }
}